export const TITLESEC_DESIGN_TYPE = {
  HEADER: 'headerText',
  LABEL: 'label',
} as const;

export type TITLESEC_DESIGN_TYPE_KEY = keyof typeof TITLESEC_DESIGN_TYPE;

export type TITLESEC_DESIGN_TYPE_VALUE =
  typeof TITLESEC_DESIGN_TYPE[TITLESEC_DESIGN_TYPE_KEY];

export const TITLESEC_DESIGN_TYPE_MAP = {
  [TITLESEC_DESIGN_TYPE.HEADER]: '제목형',
  [TITLESEC_DESIGN_TYPE.LABEL]: '라벨형',
};

export const titleDesignTypeList = Object.keys(TITLESEC_DESIGN_TYPE_MAP).map(
  (key) => {
    return {
      key: key,
      value: TITLESEC_DESIGN_TYPE_MAP[key],
    };
  },
);
